import { httpApi } from '@api/http.api.ts';
import type { CommonTableRequest } from '@routes/sidebar/admin-center/___shared___/types.ts';
import type { PaginatedResponse } from '@types';
import type { AxiosResponse } from 'axios';

export type CommonSubscriptionsRequest = CommonTableRequest;

export interface SubscriptionsResultsDescription {
    activeCount: number;
    totalCount: number;
}

export interface Subscription {
    id: number;
    pathwayId: string;
    adminPathwayId: string;
    pathwayTitle: string;
    type: string;
    version: string;
    createdBy: string;
    createdFor: string;
    timeInMinutes: number;
    isActive: boolean;
    canDeactivate: boolean;
    publishedDateAtUtc: string;
}

export interface UpdateSubscriptionActivationRequest {
    isActive: boolean;
}

const getBaseUrl = (clientId: number, tenantAlias: string) =>
    `admin-center/clients/${clientId}/tenants/${tenantAlias}/subscriptions`;

export const getApiSubscriptions = (
    clientId: number,
    tenantAlias: string,
    payload: CommonSubscriptionsRequest,
): Promise<PaginatedResponse<Subscription, SubscriptionsResultsDescription>> =>
    httpApi
        .post<
            PaginatedResponse<Subscription, SubscriptionsResultsDescription>
        >(`${getBaseUrl(clientId, tenantAlias)}/search`, payload)
        .then(({ data }) => data);

export const putSubscriptionActivation = (
    clientId: number,
    tenantAlias: string,
    adminPathwayId: string,
    payload: UpdateSubscriptionActivationRequest,
): Promise<any> =>
    httpApi.put<any>(`${getBaseUrl(clientId, tenantAlias)}/${adminPathwayId}`, payload).then(({ data }) => data);

export const downloadApiSubscriptionsCsv = (clientId: number, tenantAlias: string): Promise<AxiosResponse<Blob>> =>
    httpApi
        .get(`${getBaseUrl(clientId, tenantAlias)}/download-csv`, {
            responseType: 'blob',
        })
        .then((res) => res);
